const state = {
  isMenuOpen: false,
};

const mutations = {
  TOGGLE_LANG_MENU(state) {
    state.isMenuOpen = !state.isMenuOpen;
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/langSelector.js